var render = function render(_c, _vm) {
  return _c("div", { staticClass: "loader-wrapper" }, [
    _c("picture", [
      _vm.props.brandName === "Travelsphere"
        ? _c("img", {
            attrs: {
              src: "/Static/images/gif/ts-checkout-loader.gif",
              alt: "CheckoutLoader",
              loading: "lazy",
            },
          })
        : _c("img", {
            attrs: {
              src: "/Static/images/gif/checkout-loader-j.gif",
              alt: "CheckoutLoader",
              loading: "lazy",
            },
          }),
    ]),
    _vm._v(" "),
    _c("p", [_vm._v("We are building your holiday")]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }